import { useEffect, useState } from "react";
import Sidebar from "../components/SidebarUpdate";
import Footer from "../components/Footer";
import apiInstance from "../apiConfig/apiinstance";
import Breadcrumb from "../components/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import year_background from "../assest/images/year_background.jpg";
import season_background from "../assest/images/season_background.jpeg";
import { ClipLoader } from "react-spinners";

const MsrSeasons = () => {
  const [msrCategories, setMSRCategories] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isByYear, setIsByYear] = useState(false);
  const [isYearData, setIsYearData] = useState(false);
  const [currentYear, setCurrentYear] = useState(null);

  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const navigate = useNavigate();

  // const fullUrl = isByYear
  //   ? `${BaseUrl()}/api/msr/v1/msr/msr_season_year_wise_list/`
  //   : `${BaseUrl()}/api/msr/v1/msr/msr_season/`;

  // Fetch all categories or year list
  // const fetchMSRCategories = async () => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const { data } = await axios.get(fullUrl);
  //     if (data.status === 200) {
  //       if (!data?.data?.results?.length) {
  //         setError("No MSR categories found");
  //         setMSRCategories([]);
  //       } else {
  //         setMSRCategories(data.data.results);
  //       }
  //     }
  //   } catch (error) {
  //     setError(
  //       error?.response?.data?.message || "Error fetching msr categories"
  //     );
  //     setMSRCategories([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Fetch seasons for a specific year
  // const fetchSeasonsForYear = async (year) => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const { data } = await axios.get(
  //       `${BaseUrl()}/api/msr/v1/get-year-season/${year}`
  //     );
  //     if (data.status === 200) {
  //       if (!data?.data?.length) {
  //         setError("No MSR category styles found");
  //         setMSRCategories([]);
  //       } else {
  //         setMSRCategories(data.data);
  //       }
  //     }
  //   } catch (error) {
  //     setError(
  //       error?.response?.data?.message || "Error fetching msr category styles"
  //     );
  //     setMSRCategories([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handle toggling between year and season view
  const handleToggleView = () => {
    if (isByYear) {
      navigate("/msr-seasons/season");
    } else {
      navigate("/msr-seasons/year");
    }
  };

  // Handle clicking a year card
  const handleYearClick = async (item) => {
    setCurrentYear(item.slug);
    setIsYearData(false);
    setLoading(true);
    setError(null);
    try {
      const { data } = await apiInstance.get(
        `/api/msr/v1/get-year-season/${item.slug}`
      );
      if (data.status === 200 && data?.data?.length) {
        setMSRCategories(data.data);
        navigate(`/msr-seasons/year/${item.slug}`);
      } else {
        setMSRCategories([]);
        setError("No MSR category styles found");
      }
    } catch (error) {
      setError(
        error?.response?.data?.message || "Error fetching msr category styles"
      );
      setMSRCategories([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle clicking a season card or breadcrumb
  // const handleCategoryChange = (newPath) => {
  //   console.log("new path in msr seasons - ", newPath);
  //   if (!newPath) return;
  //   if (isYearData) {
  //     handleYearClick({ slug: newPath });
  //   } else {
  //     navigate(newPath);
  //   }
  // };

  // Handle clicking a season card or breadcrumb
  const handleCategoryChange = (newPath) => {
    if (!newPath) return;

    // Check if the newPath is a year navigation (contains /year/ followed by a year)
    const yearMatch = newPath.match(/\/msr-seasons\/year\/(\d{4})/);

    if (yearMatch) {
      const year = yearMatch[1];

      // If we're already showing data for this specific year, go back to year list
      if (currentYear === year && !isYearData) {
        // Navigate back to year list view
        setIsByYear(true);
        setIsYearData(true);
        setCurrentYear(null);
        navigate("/msr-seasons/year");
      } else {
        // Navigate to this specific year
        handleYearClick({ slug: year });
      }
    } else {
      navigate(newPath);
    }
  };

  // useEffect(() => {
  //   const lastSegment = pathSegments.at(-1);
  //   if (lastSegment === "year") {
  //     setIsByYear(true);
  //     setIsYearData(true);
  //     setCurrentYear(null);
  //     setLoading(true);
  //     setError(null);
  //     axios
  //       .get(`${BaseUrl()}/api/msr/v1/msr/msr_season_year_wise_list/`)
  //       .then(({ data }) => {
  //         if (data.status === 200 && data?.data?.results?.length) {
  //           setMSRCategories(data.data.results);
  //         } else {
  //           setMSRCategories([]);
  //           setError("No MSR categories found");
  //         }
  //       })
  //       .catch((error) => {
  //         setError(
  //           error?.response?.data?.message || "Error fetching msr categories"
  //         );
  //         setMSRCategories([]);
  //       })
  //       .finally(() => setLoading(false));
  //   } else if (lastSegment === "season") {
  //     setIsByYear(false);
  //     setIsYearData(false);
  //     setCurrentYear(null);
  //     setLoading(true);
  //     setError(null);
  //     axios
  //       .get(`${BaseUrl()}/api/msr/v1/msr/msr_season/`)
  //       .then(({ data }) => {
  //         if (data.status === 200 && data?.data?.results?.length) {
  //           setMSRCategories(data.data.results);
  //         } else {
  //           setMSRCategories([]);
  //           setError("No MSR categories found");
  //         }
  //       })
  //       .catch((error) => {
  //         setError(
  //           error?.response?.data?.message || "Error fetching msr categories"
  //         );
  //         setMSRCategories([]);
  //       })
  //       .finally(() => setLoading(false));
  //   }
  //   // eslint-disable-next-line
  // }, [location.pathname]);

  useEffect(() => {
    const lastSegment = pathSegments.at(-1);

    // Check if we're in year view (either /year or /year/2025)
    if (pathSegments.includes("year")) {
      // If the path is /msr-seasons/year/2025 (specific year)
      if (lastSegment && lastSegment.match(/^\d{4}$/)) {
        const year = lastSegment;
        setIsByYear(true);
        setIsYearData(false);
        setCurrentYear(year);

        // Fetch seasons for this specific year
        setLoading(true);
        setError(null);
        apiInstance
          .get(`/api/msr/v1/get-year-season/${year}`)
          .then(({ data }) => {
            if (data.status === 200 && data?.data?.length) {
              setMSRCategories(data.data);
            } else {
              setMSRCategories([]);
              setError("No MSR categories found");
            }
          })
          .catch((error) => {
            setError(
              error?.response?.data?.message || "Error fetching msr categories"
            );
            setMSRCategories([]);
          })
          .finally(() => setLoading(false));
      }
      // If the path is /msr-seasons/year (year list)
      else if (lastSegment === "year") {
        setIsByYear(true);
        setIsYearData(true);
        setCurrentYear(null);
        setLoading(true);
        setError(null);
        apiInstance
          .get(`/api/msr/v1/msr/msr_season_year_wise_list/`)
          .then(({ data }) => {
            if (data.status === 200 && data?.data?.results?.length) {
              setMSRCategories(data.data.results);
            } else {
              setMSRCategories([]);
              setError("No MSR categories found");
            }
          })
          .catch((error) => {
            setError(
              error?.response?.data?.message || "Error fetching msr categories"
            );
            setMSRCategories([]);
          })
          .finally(() => setLoading(false));
      }
    }
    // If the path is /msr-seasons/season
    else if (lastSegment === "season") {
      setIsByYear(false);
      setIsYearData(false);
      setCurrentYear(null);
      setLoading(true);
      setError(null);
      apiInstance
        .get(`/api/msr/v1/msr/msr_season/`)
        .then(({ data }) => {
          if (data.status === 200 && data?.data?.results?.length) {
            setMSRCategories(data.data.results);
          } else {
            setMSRCategories([]);
            setError("No MSR categories found");
          }
        })
        .catch((error) => {
          setError(
            error?.response?.data?.message || "Error fetching msr categories"
          );
          setMSRCategories([]);
        })
        .finally(() => setLoading(false));
    }
  }, [location.pathname]);

  return (
    <div className="parent_Container">
      <div className="content_wrapper py-4 px-8">
        <Sidebar logo="FP ONE" />
        <div className="content_wrapper_child overflow-hidden">
          <div className="flex justify-end items-center">
            <button onClick={handleToggleView}>
              {!isByYear ? "see by years" : "see by seasons"}
            </button>
          </div>

          <div className="separator"></div>
          <Breadcrumb onCategoryClick={handleCategoryChange} isMSR={true} />
          {/* <h1>MSR Seasons</h1> */}

          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
          ) : (
            <div className="sm:p-4 p-2">
              {error && (
                <div className="no-products loader-container">{error}</div>
              )}
              {msrCategories.length === 0 && !error ? (
                <div className="no-products loader-container">
                  No Products Found
                </div>
              ) : isYearData ? (
                <div className="flex gap-y-4 sm:gap-4 flex-wrap">
                  {msrCategories.map((item) => (
                    <div
                      key={item.slug}
                      className="msr_container relative"
                      onClick={() => handleYearClick(item)}
                    >
                      <img
                        src={item.cover_image || year_background}
                        className="image"
                        alt={`${item.year_value}`}
                      />
                      <span className="font-bold absolute text-amber-900 left-[13%] text-8xl">
                        {item.year_value}
                      </span>
                      <span className="font-bold">{item.year_value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex gap-y-4 sm:gap-4  flex-wrap">
                  {msrCategories.map((item) => (
                    <div
                      key={item.msr_season_id}
                      className="msr_container"
                      onClick={() => handleCategoryChange(item.season_slug)}
                    >
                      <img
                        src={item.cover_image || season_background}
                        className="image"
                        alt={`${item.season_name}`}
                      />
                      <span className="font-bold">{item.season_name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MsrSeasons;
